import { render, staticRenderFns } from "./Sso.vue?vue&type=template&id=06ab9e11&"
import script from "./Sso.vue?vue&type=script&lang=js&"
export * from "./Sso.vue?vue&type=script&lang=js&"
import style0 from "./Sso.vue?vue&type=style&index=0&id=06ab9e11&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports